import React from 'react';
import { Composition } from 'remotion';
import {
  VideoCommentary,
  calculateVideoCommentaryMetadata,
  videoCommentarySchema,
} from '../templates/custom/video-commentary';
import {
  VideoCommentaryHighlight,
  calculateVideoCommentaryHighlightMetadata,
  videoCommentaryHighlightSchema,
} from '../templates/custom/video-commentary-highlight';
import {
  VideoHighlight,
  calculateVideoHighlightMetadata,
  videoHighlightSchema,
} from '../templates/custom/video-highlight';
import {
  TimingDebugPattern,
  TIMING_DEBUG_DURATION_SECONDS,
  TIMING_DEBUG_FPS,
} from '../templates/custom/video-commentary/TimingDebugPattern';
import { defaultVideoCommentaryProps } from './videoCommentaryData';
import {defaultVideoCommentaryHighlightProps} from './videoCommentaryHighlightData';
import { debugVideoCommentaryProps } from './videoCommentaryDebugData';
import {
  defaultVideoHighlightProps,
  videoHighlightDatasets,
} from './videoHighlightData';
import { videoCommentaryRegressionScenarios } from './videoCommentaryRegressionData';

export const CustomTemplatesCompositions: React.FC = () => {
  return (
    <>
      {/* 仅保留生产入口路由（被 demo-consumer / scripts / lib 导出引用）：
          - VideoCommentary
          - VideoCommentaryHighlight
          - VideoHighlight
          其余 TimingDebug / Regression / Showcase / ReferenceSunset 仅用于本地
          调试与回归测试，目前未被外部引用，已注销以保持 Studio 路由清单整洁。
          如需调试，可临时取消相应区块的注释。 */}

      <Composition
        id="VideoCommentary"
        component={VideoCommentary}
        schema={videoCommentarySchema}
        calculateMetadata={calculateVideoCommentaryMetadata}
        durationInFrames={300}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={defaultVideoCommentaryProps}
      />

      <Composition
        id="VideoCommentaryHighlight"
        component={VideoCommentaryHighlight}
        schema={videoCommentaryHighlightSchema}
        calculateMetadata={calculateVideoCommentaryHighlightMetadata}
        durationInFrames={300}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={defaultVideoCommentaryHighlightProps}
      />

      <Composition
        id="VideoHighlight"
        component={VideoHighlight}
        schema={videoHighlightSchema}
        calculateMetadata={calculateVideoHighlightMetadata}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={defaultVideoHighlightProps}
      />

      {/*
      <Composition
        id="VideoCommentaryTimingDebugSource"
        component={TimingDebugPattern}
        durationInFrames={TIMING_DEBUG_DURATION_SECONDS * TIMING_DEBUG_FPS}
        fps={TIMING_DEBUG_FPS}
        width={1920}
        height={1080}
      />

      <Composition
        id="VideoCommentaryTimingDebug"
        component={VideoCommentary}
        schema={videoCommentarySchema}
        calculateMetadata={calculateVideoCommentaryMetadata}
        durationInFrames={300}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={debugVideoCommentaryProps}
      />

      <Composition
        id="VideoCommentaryRegressionContiguousMixed"
        component={VideoCommentary}
        schema={videoCommentarySchema}
        calculateMetadata={calculateVideoCommentaryMetadata}
        durationInFrames={300}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={videoCommentaryRegressionScenarios.businessContiguousMixed}
      />

      <Composition
        id="VideoCommentaryRegressionDecimalCuts"
        component={VideoCommentary}
        schema={videoCommentarySchema}
        calculateMetadata={calculateVideoCommentaryMetadata}
        durationInFrames={300}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={videoCommentaryRegressionScenarios.businessDecimalCuts}
      />

      <Composition
        id="VideoCommentaryRegressionLeadingAndGaps"
        component={VideoCommentary}
        schema={videoCommentarySchema}
        calculateMetadata={calculateVideoCommentaryMetadata}
        durationInFrames={300}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={videoCommentaryRegressionScenarios.businessLeadingAndGaps}
      />

      <Composition
        id="VideoHighlightShowcase"
        component={VideoHighlight}
        schema={videoHighlightSchema}
        calculateMetadata={calculateVideoHighlightMetadata}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={videoHighlightDatasets.demoShowcase}
      />

      <Composition
        id="VideoHighlightReferenceSunset"
        component={VideoHighlight}
        schema={videoHighlightSchema}
        calculateMetadata={calculateVideoHighlightMetadata}
        durationInFrames={300}
        fps={24}
        width={1080}
        height={1920}
        defaultProps={videoHighlightDatasets.referenceSunsetMarkers}
      />
      */}
    </>
  );
};
